<template>
    <div class="product-categories">
        <section class="product good" v-if="$route.params.product === this.$parent.products.good.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.good.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.good.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.good.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.good.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.good.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.good.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.good.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.good.pliant_titlu }}</h3>
                <a :href="this.$parent.products.good.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.good.pliant_preturi.imgSrc" :alt="this.$parent.products.good.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL GOOD -->

        <section class="product better" v-if="$route.params.product === this.$parent.products.better.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.better.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.better.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.better.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.better.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.better.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.better.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.better.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.better.pliant_titlu }}</h3>
                <a :href="this.$parent.products.better.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.better.pliant_preturi.imgSrc" :alt="this.$parent.products.better.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC BETTER -->

        <section class="product better-safe-pvc" v-if="$route.params.product === this.$parent.products.better_safe_pvc.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.better_safe_pvc.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.better_safe_pvc.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.better_safe_pvc.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.better_safe_pvc.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.better_safe_pvc.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.better_safe_pvc.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.better_safe_pvc.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.better_safe_pvc.pliant_titlu }}</h3>
                <a :href="this.$parent.products.better_safe_pvc.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.better_safe_pvc.pliant_preturi.imgSrc" :alt="this.$parent.products.better_safe_pvc.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC BETTER SAFE PVC -->

        <section class="product ultima" v-if="$route.params.product === this.$parent.products.ultima.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.ultima.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.ultima.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.ultima.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.ultima.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.ultima.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.ultima.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.ultima.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.ultima.pliant_titlu }}</h3>
                <a :href="this.$parent.products.ultima.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.ultima.pliant_preturi.imgSrc" :alt="this.$parent.products.ultima.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC ULTIMA -->

        <section class="product better-energy" v-if="$route.params.product === this.$parent.products.better_energy.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.better_energy.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.better_energy.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.better_energy.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.better_energy.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.better_energy.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.better_energy.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.better_energy.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.better_energy.pliant_titlu }}</h3>
                <a :href="this.$parent.products.better_energy.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.better_energy.pliant_preturi.imgSrc" :alt="this.$parent.products.better_energy.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC BETTER ENERGY -->

        <section class="product better-energy-pvc" v-if="$route.params.product === this.$parent.products.better_energy_pvc.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.better_energy_pvc.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.better_energy_pvc.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.better_energy_pvc.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.better_energy_pvc.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.better_energy_pvc.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.better_energy_pvc.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.better_energy_pvc.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.better_energy_pvc.pliant_titlu }}</h3>
                <a :href="this.$parent.products.better_energy_pvc.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.better_energy_pvc.pliant_preturi.imgSrc" :alt="this.$parent.products.better_energy_pvc.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC BETTER ENERGY PVC -->

        <section class="product flex" v-if="$route.params.product === this.$parent.products.flex.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.flex.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.flex.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.flex.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.flex.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.flex.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.flex.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.flex.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.flex.pliant_titlu }}</h3>
                <a :href="this.$parent.products.flex.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.flex.pliant_preturi.imgSrc" :alt="this.$parent.products.flex.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL FLEX -->

        <section class="product control" v-if="$route.params.product === this.$parent.products.control.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.control.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <div class="row qualities">
                    <div class="col-md-4" v-for="quality in this.$parent.products.control.calitati" :key="quality.id">
                        <div class="quality">
                            <div class="img-wrapper">
                                <img :src="quality.imgSrc" :alt="quality.nume">
                            </div>
                            <h5>{{ quality.nume }}</h5>
                            <p v-html="quality.descriere"></p>
                        </div>
                    </div>
                </div>
                <h2 class="product-title">{{ this.$parent.products.control.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.control.descriere"></div>
                <h3 class="product-title">{{ this.$parent.products.control.info_technice.titlu }}</h3>
                <div class="product-info row">
                    <div class="col-sm-6" v-for="category in this.$parent.products.control.info_technice.categorii" :key="category.id">
                        <div class="product-info__category">
                            <img :src="category.imgSrc" :alt="category.nume">
                            <h5>{{ category.nume }}</h5>
                            <p>{{ category.descriere }}</p>
                        </div>
                    </div>
                </div>
                <div class="product-info__specifications" v-html="this.$parent.products.control.info_technice.specificatii"></div>
                <h3 class="product-title">{{ this.$parent.products.control.pliant_titlu }}</h3>
                <a :href="this.$parent.products.control.pliant_preturi.href" target="_blank">
                    <img :src="this.$parent.products.control.pliant_preturi.imgSrc" :alt="this.$parent.products.control.pliant_titlu">
                </a>
            </div>
        </section>
        <!-- END SECTION PROFIL CONTROL -->

    </div>
    
</template>
<script>
export default {
  data() {
    return {
      name: "dakeaProducts",
      options: {
        arrows: true,
        dots: true,
        speed: 750,
        fade: false,
        pauseOnHover: true,
        infinite: true,
        autoplay: true
      }
    };
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";

/*=============================================
=            RESPONSIVE            =
=============================================*/

@media (max-width: 991.98px) {
  .page-dakea {
    .product-info {
      &__specifications {
        width: 100%;
      }
    }
  }
}

@media (max-width: 767.98px) {
  .page-dakea {
    .product-info {
      &__category {
        img {
          width: 100%;
        }
      }
    }
  }
}

@media (max-width: 575.98px) {
  .page-dakea {
    .product-info {
      &__category {
        img {
          width: auto;
        }
      }
      &__specifications {
        li {
          display: block;
          strong {
            display: block;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/dakeaProducts.vue